<template>
<div class="bmd-form-group form-group select-float"
  v-bind:class="{ 'is-focused' : focused, 'is-filled': !!modelValue, 'invalid': submited && !modelValue}"
  @mouseover="hovered = true"
  @mouseout="hovered = false">
  <div class="select-wrapper">
    <label :for="id"
      class="bmd-label-floating">{{title}}</label>
    <select :value="modelValue"
      @input="e => handleSelect(e.target.value)"
      :id="id"
      @focus="handleFocus"
      class="form-control"
      @invalid="handleInvalid"
      :required="required"
      :disabled="disabled">
      <option v-for="item in list" :style="(hovered ? 'display:none' : '')"
        :selected="modelValue == item.id"
        :value="item.id">{{item.name}}</option>
    </select>
    <ul class="dropdown-menu custom-dropdown"
      :class="{show: focused}">
      <li v-for="item in list"
        :class="{selected: item.id === v}">
        <div @click="handleSelect(item.id)">{{item.name}}</div>
      </li>
    </ul>

    <icon name="keyboard_arrow_down"
      class="arrow-down" />
  </div>
  <toggle-height>
    <div class="error-msg"
      v-if="submited && !modelValue">{{errorMsg}}</div>
  </toggle-height>
</div>
</template>

<script>
export default
{
  name: "SelectFloat",
  props:
  {
    id: String,
    disabled:
    {
      type: Boolean,
      default: false
    },
    title:
    {
      type: String,
      default: "title"
    },
    list: Array,
    modelValue:
    {
      type: String,
      default: ""
    },
    required:
    {
      type: Boolean,
      default: false
    },
    errorMsg:
    {
      type: String,
      default: "Este campo es obligatorio."
    },
  },
  data()
  {
    return {
      v: '',
      focused: false,
      hovered: false,
      submited: false,
      valid: true,
      selected: false
    }
  },
  // watch:
  // {
  //   v: function ( v )
  //   {
  //     this.$emit( "input", v )
  //   },
  //   value:
  //   {
  //     handler( value )
  //     {
  //       this.v = value;
  //     },
  //     immediate: true
  //   }
  // },
  mounted()
  {
    window.addEventListener( "click", e =>
    {
      if ( this.selected )
      {
        this.selected = false
      }
      else
      {
        if ( this.hovered )
        {
          this.focused = true
        }
        else
        {
          this.focused = false
        }

      }
    } )
  },
  methods:
  {
    handleFocus( e )
    {
      if(this.hovered){
        e.target.blur()
      }
    },
    handleSelect( e )
    {
      this.$emit( "update:modelValue", e )
      this.focused = false
      this.selected = true
    },
    handleInvalid( e )
    {
      this.submited = true
      this.valid = false
      e.preventDefault();
    },
  }

}
</script>

<style lang="scss">
@import "../../../sass/variables"; // Variables
.select-float {

    .arrow-down {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 10px;
        font-size: 35px;
        line-height: 35px;
        color: $color-brand-1;
        background-color: $white;
        pointer-events: none;
        border-radius: 5px;
        height: 36px;
    }
}
.form-control:read-only{
  background-image: none;
}
.custom-dropdown {
    width: 100%;
    max-height: 0;
    transition: max-height 0.1s ease;
    overflow-y: auto;
    display: block;
    border-radius: 5px;
    color: $color-text;
    &.show {
        max-height: 300px;
    }
    li {
        margin: 0 7px;
        padding: 6px 14px;
        cursor: pointer;
        &.selected {
            color: $color-text;
        }
        &:hover {
            background-color: $primary;
            color: $color-text;
            border-radius: 8px;
        }
    }
}
.error-msg{
  color: $red;
}
</style>
